"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import { Typography } from "@/components/ui/typography";
import Icon from "@/components/ui/Icon";

type WhyChooseCardProps = {
  title?: string;
  description?: string;
  items?: string[];
} & React.ComponentProps<"div">;

export const WhyChooseCard = ({
  title,
  description,
  items,
  className,
}: WhyChooseCardProps) => {
  if (!title && !description && !items?.length) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex bg-background-secondary border border-neutral-200 rounded-3xl lg:rounded-2xl lg:border-neutral-100",
        className
      )}
    >
      <div className="grid grid-cols-1 gap-6 place-content-start flex-auto min-w-0 p-6 md:py-8">
        {(!!title || !!description) && (
          <div className="grid grid-cols-1 gap-2 place-content-start sm:text-center">
            {!!title && (
              <div className="text-semantic-text-primary text-2xl leading-[120%] font-semibold lg:text-gray-800 lg:text-[32px] lg:leading-[150%] lg:font-medium">
                <h3>{title}</h3>
              </div>
            )}
            {!!description && (
              <div className="leading-[130%] lg:leading-[145%] tex-gray-600">
                {description}
              </div>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 gap-x-4 gap-y-6 place-content-start sm:grid-cols-2 md:grid-cols-3">
          {items?.map((description, i) => {
            return (
              <div className="flex items-start" key={i}>
                <Icon
                  id="icon-check-in-circle_32"
                  className="shrink-0 text-blue w-8 h-8 mr-4 md:w-7 md:h-7 md:mr-2.5"
                />
                <Typography
                  variant="labelMd"
                  className="flex-auto min-w-0 text-semantic-text-primary lg:text-base lg:leading-[150%] lg:text-[#1b1f3b]"
                  asChild
                >
                  <p>{description}</p>
                </Typography>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default memo(WhyChooseCard);
